export const initialState = {
  downloadTrackers: [],
  downloadPendings: []
};
